// Coarse world areas derived from an event's coordinates (no content change needed).
export const AREAS = [
  { id: 'eu', name: 'אירופה' },
  { id: 'mena', name: 'המזרח התיכון וצפון אפריקה' },
  { id: 'ssa', name: 'אפריקה שמדרום לסהרה' },
  { id: 'ca', name: 'מרכז אסיה' },
  { id: 'sa', name: 'דרום אסיה' },
  { id: 'ea', name: 'מזרח אסיה' },
  { id: 'seo', name: 'דרום־מזרח אסיה ואוקיאניה' },
  { id: 'na', name: 'צפון אמריקה' },
  { id: 'la', name: 'מרכז ודרום אמריקה' },
];

export function areaOf(lat, lon) {
  // Americas (and Hawaii)
  if (lon < -30) return lon < -140 && lat < 35 ? 'seo' : lat >= 25 ? 'na' : 'la';
  if (lon >= 165 || (lat < -10 && lon > 110) || (lon >= 141 && lat < 0)) return 'seo';
  // Anatolia is Middle East, except Istanbul's side of the straits
  if (lat >= 40.8 && lon >= 26 && lon <= 29.5) return 'eu';
  // North African coast below Europe's southern edge
  if (lat < 37.5 && lat > 20 && lon > -2 && lon < 12.5) return 'mena';
  // Greece, Crete, Sicily, Malta
  if (lat >= 34.8 && lon >= 12.5 && lon <= 26.2 && !(lat < 36 && lon < 19)) return 'eu';
  // Europe incl. western Russia
  if (lat >= 36 && lon >= -25 && lon <= 26) return 'eu';
  if (lat >= 46 && lon > 26 && lon <= 60) return 'eu';
  if (lat >= 44 && lon > 26 && lon <= 40) return 'eu';
  // Sub-Saharan Africa
  if (lon > -20 && lon < 52 && (lat < 18 || (lat < 20 && lon < 0)) && !(lat >= 12 && lon >= 43)) return 'ssa';
  // Middle East and North Africa
  if (lon > -20 && lon <= 62 && lat >= 12 && lat < 46 && !(lat > 37 && lon > 50)) return 'mena';
  // Asia
  if (lat > 37 && lon > 50 && lon < 90) return 'ca';
  if (lat >= 28 && lat < 37 && lon >= 80 && lon < 100) return 'ea'; // Tibet
  if (lon >= 60 && lon < 93 && lat >= 5) return 'sa';
  if (lon >= 93 && lat >= 22) return 'ea';
  if (lon >= 88 && lat > 45) return 'ea';
  if (lon >= 92) return 'seo';
  return 'mena';
}
